import { Delete, Get, Post, Put } from "#src/HttpClient.ts";
import { type Pinia } from "pinia";

const controller = "/strife/v1/electronic_application_cases";

export async function createEappCase(
  pinia: Pinia,
  electronic_application_case: any
) {
  const { data } = await Post(pinia, {
    url: controller,
    body: { electronic_application_case },
    includeEappData: true,
  });

  return data.electronic_application_case;
}

export async function updateCoverage(
  pinia: Pinia,
  coverageId: number,
  electronic_application_case: any
) {
  return Put(pinia, {
    url: `${controller}/${coverageId}`,
    body: { electronic_application_case },
    includeEappData: true,
  });
}

export async function deleteEappCase(pinia: Pinia, coverageId: number) {
  return Delete(pinia, {
    url: `${controller}/${coverageId}`,
    includeEappData: true,
  });
}

interface RawCoverageCarrier {
  id: number;
  name: string;
}
export async function getCoverageCarriers(pinia: Pinia) {
  const { data } = await Get(pinia, {
    url: `${controller}/carriers`,
  });

  return data.carriers.map((a: RawCoverageCarrier) => ({
    value: a.id,
    title: a.name,
  }));
}
